module.exports = __webpack_public_path__ + "media/images/pikawakasan-a063a71df7c6f4ec66609762a5f62e38.png";